import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environment';
import { emsBadgeLogs, emsBadgeLogEntry } from 'src/models/emsModels';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-badge-meal-counter-external',
  templateUrl: './badge-meal-counter-external.component.html',
  styleUrl: './badge-meal-counter-external.component.scss'
})
export class BadgeMealCounterExternalComponent {
  notificationBar: NotificationBar;
  workspaceID = "";
  displayedColumns: string[] = ['date', 'total'];
  mealCounterSource = new MatTableDataSource<emsBadgeLogs>;
  searchValue: string;
  badgesMealsDBRef: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private title: Title, private location: Location, private snackBar: MatSnackBar, public dialog: MatDialog, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
   }

  ngOnInit() {
    this.workspaceID  = this.location.path().split("/")[1];
    this.title.setTitle("Meal Counter - External View - EsportsMS");
    var auth = false;
    var pw = "RGA2025";
    while (!auth) {
      const pwEntered = prompt('Enter Password:');
      if (pwEntered == pw) {
        auth = true;
      }
    }
    this.loadMeals();
  }

  ngOnDestroy() {
    if (this.badgesMealsDBRef) {
      this.badgesMealsDBRef.off('value');
    };
  }

  mealCounterSearch(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
    this.mealCounterSource.filter = this.searchValue.trim().toLowerCase();
  }

  loadMeals() {
    this.badgesMealsDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/meals');
    this.badgesMealsDBRef.on('value', x => {
      const rawData = x.toJSON();
      var badgeLogList = new Array<emsBadgeLogs>();
      Object.keys(rawData).forEach(key => { 
        var badgeLogEntries = Object.values(rawData[key]) as Array<emsBadgeLogEntry>;
        var badgeLogs = new emsBadgeLogs();
        var dateString = key;
        var [day, month, year] = dateString.split("-").map(num => parseInt(num, 10));
        var dateObject = new Date(year, month - 1, day);
        badgeLogs.date = dateObject;
        badgeLogs.total = badgeLogEntries.length;
        badgeLogList.push(badgeLogs);
      });
      badgeLogList.sort((a, b) => b.date.getTime() - a.date.getTime());
      this.mealCounterSource = new MatTableDataSource(badgeLogList);
      this.mealCounterSource.sort = this.sort;
      this.mealCounterSource.paginator = this.paginator;
    });
  }
}
